import * as React from 'react'
import cx from 'classnames'
import style from './Team.css'
import shape from '_images/shape1.svg'
import shape1 from '_images/shape.svg'

import IconTwitter from './icons/twitter.svg'
import IconLinkedin from './icons/linkedin.svg'
import IconMail from './icons/mail.svg'
import IconMedium from './icons/medium.svg'
import IconCancel from './icons/cancel.inline.svg'

import { Avatar } from './Avatar'
import { current, advisors, alumni } from './data'
import { Collapse } from 'react-collapse';

let peopleCurrent = current.map((element, index) => ({ ...element, index }));
let peopleAdvisors = advisors.map((element, index) => ({ ...element, index }));
let peopleAlumni = alumni.map((element, index) => ({ ...element, index }));
let WOW = function () {
}
if (typeof window !== 'undefined') {
    WOW = require('wowjs')
}


const Social = ({ socials }) => (
    <div className={style.social}>
        {socials.twitter && <a target="_blank" href={`https://twitter.com/${socials.twitter}`} className={style.socialLink} rel="noreferrer">
            <img src={IconTwitter} alt="twitter" />
        </a>}
        {socials.medium && <a target="_blank" href={`https://blockscience.ghost.io${socials.medium}`} className={style.socialLink} rel="noreferrer">
            <img src={IconMedium} alt="medium" />
        </a>}
        {socials.linkedin && <a target="_blank" href={`https://www.linkedin.com/in/${socials.linkedin}`} className={style.socialLink} rel="noreferrer">
            <img src={IconLinkedin} alt="linkedin" />
        </a>}
        {socials.email && <a target="_blank" href={`mailto:${socials.email}`} className={style.socialLink} rel="noreferrer">
            <img src={IconMail} alt="google" />
        </a>}
    </div>
)

function Person({ person, index, focus, setFocus }) {
    const isFocus = person.index === focus;
    return <li key={index}
        className={cx(style.item, `wow ${index % 2 === 0 ? 'fadeInLeft' : 'fadeInRight'}`)}>
        <div className={style.itemImage} onClick={() => isFocus ? setFocus(-1) : setFocus(person.index)} >
            {index % 3 == 0 &&
                <img className={cx(style.shape, style.shapeAvatar1, 'rotation slow')}
                    src={shape1}
                />}
            {index % 3 == 0 &&
                <img className={cx(style.shape, style.shapeAvatar2, 'rotation faster')}
                    src={shape1} />}

            {index % 5 === 0 &&
                <img className={cx(style.shape, style.shapeAvatar3, 'rotation slow')}
                    src={shape1} />}
            {index % 5 === 0 &&
                <img className={cx(style.shape, style.shapeAvatar6, 'rotation slow')}
                    src={shape1} />}

            <div type="button" className={cx(style.bioLink)}>
                <Avatar
                    src={person.avatar}
                    alt={person.name}
                />
                <h4>{person.name}</h4>
                <h5 style={{marginBottom: '0px'}}>{person.position}</h5>
                <h5 style={{fontWeight: '500'}}>{person.positionDetail}</h5>
            </div>
            {/* <Social socials={person.socials} /> */}
        </div>
    </li>
}

function TeamList({ people, focus, setFocus }) {
    const queryMobile = window.matchMedia("(max-width: 962px)")
    const isMobile = queryMobile.matches
    const everyN = isMobile ? 1 : 4
    const getFocusIndex = (i) => (5 * (Math.floor(i / everyN) + 1)) - 1
    const currentFocusIndex = focus !== -1 ? getFocusIndex(focus) : -1
    const focusPerson = people[focus] ? people[focus] : ''
    return (
        <ul className={style.list}>
            {
                people.map((person, index) => (
                    <Person key={'person' + index} person={person} index={index} focus={focus} setFocus={setFocus} />
                )).reduce(function (result, person, index, array) {
                    result.push(person);
                    const linkedin = person.props.person.socials.linkedin
                    function linkedinComponent() {
                        if (linkedin) {
                            return <a target="_blank" href={`https://www.linkedin.com/in/${linkedin}`}    style={{
                                paddingLeft: '10px',
                                verticalAlign: 'bottom'
                            }}  className={style.socialLink} rel="noreferrer">
                                <img src={IconLinkedin} alt="linkedin" />
                            </a>
                        }
                    }

                    if ((index + 1) % everyN === 0 || index === array.length - 1) {
                        result.push(<Collapse key={'collapse' + index} theme={{
                            collapse: isMobile ?  style.collapseContainerMobile : style.collapseContainer,
                            content: isMobile ?  style.collapseContentMobile : style.collapseContent
                        }} isOpened={currentFocusIndex === getFocusIndex(index)}>
                            <h6>{focusPerson.name}
                                {/* {linkedinComponent()} */}
                            </h6><p>{focusPerson.description}</p>
                        </Collapse>);
                    }
                    return result;
                }, [])

            }
        </ul >
    )
}

export function Team() {
    const [focus1, setFocus1] = React.useState(-1)
    const [focus2, setFocus2] = React.useState(-1)
    const [focus3, setFocus3] = React.useState(-1)
    const [focusContent, setFocusContent] = React.useState('')
    const setFocusGroup1 = (index) => {
        setFocus1(index)
        setFocus2(-1)
        setFocus3(-1)
    }
    const setFocusGroup2 = (index) => {
        setFocus1(-1)
        setFocus2(index)
        setFocus3(-1)
    }
    const setFocusGroup3 = (index) => {
        setFocus1(-1)
        setFocus2(-1)
        setFocus3(index)
    }
    React.useEffect(() => {
        if (typeof window !== 'undefined') {
            const wow = new WOW({
                mobile: false,
                live: true,
                scrollContainer: null,
                offset: 80
            })
            wow.init()
        }
    }, [])
    return (
        <div className={style.root}>
            <header className={style.header}>
                <img className={cx(style.shape, style.shape1, 'rotation slow')} src={shape} />
                <img className={cx(style.shape, style.shape2, 'rotation slower')} src={shape} />
                <img className={cx(style.shape, style.shape3, 'rotation slow')} src={shape} />

                <div className="container">
                    <h1 className={cx(style.title, 'wow', 'fadeInUp')}>Team</h1>
                    <p className={cx(style.text, 'wow', 'fadeInUp')} data-wow-delay="0.25s">
                        The BlockScience team is at the forefront of research and development in applied complex systems engineering.  Our international team includes experienced leaders in business process engineering, institutional design, governance simulations, data science, web3 ecosystems, lean operations, communications, thought leadership, and project management.
                    </p>

                </div>
            </header>
            <div className={style.content}>
                <img className={cx(style.shape, style.shape4, 'rotation slower')} src={shape} />
                <img className={cx(style.shape, style.shape5, 'rotation faster')} src={shape} />
                <img className={cx(style.shape, style.shape6, 'rotation slow')} src={shape} />
                <img className={cx(style.shape, style.shape7, 'rotation slow')} src={shape} />
                <div className="container">
                    <TeamList people={peopleCurrent} focus={focus1} setFocus={setFocusGroup1} focusContent={focusContent} />
                    <h3 className='wow fadeInUp'>
                            Advisors
                    </h3>
                    <TeamList people={peopleAdvisors} focus={focus2} setFocus={setFocusGroup2} focusContent={focusContent} />
                    <h3 className='wow fadeInUp'>
                            Alumni
                    </h3>
                    <TeamList people={peopleAlumni} focus={focus3} setFocus={setFocusGroup3} focusContent={focusContent} />
                </div>
            </div>
        </div>
    )
}
